import { useMutation, useQuery } from "@tanstack/react-query";
import {
  getAllEmailTemplates,
  updateEmailTemplate,
} from "api/siteSettings/emailTemplates";
import { queryClient } from "client";
import { ApiResponseType, NotificationType } from "enums";
import { printError, useUtilities } from "helpers";
import { t } from "i18next";

export function useEmailTemplates() {
  return useQuery(["emailTamplates"], getAllEmailTemplates, {
    select: (res) => res.data,
  });
}

export function useUpdateEmailTemplate() {
  const { notification } = useUtilities();
  return useMutation(updateEmailTemplate, {
    onSuccess: (res) => {
      if (res.status_code === ApiResponseType.SUCCESS) {
        notification({
          type: NotificationType.SUCCESS,
          message: t("accountSettings.emailTemplates.api.success"),
        });
        queryClient.invalidateQueries(["emailTamplates"])
      } else {
        notification({
          type: NotificationType.ERROR,
          message: printError(res.message),
        });
      }
    },
    onError: (error) => {
      notification({
        type: NotificationType.ERROR,
        message: printError(error.response.data.message),
      });
    },
  });
}
